export default function addBreaks(text = "") {
  return text && typeof text === "string"
    ? text.replace(/…\./g, "<br />")
    : text;
}
